<template>
  <div>
    <VueDraggable
      key="carouselItem"
      :model-value="props.blockChildren"
      :animation="150"
      group="carouselItems"
      item-key="carouselItem"
      handle=".drag-handle"
      class="space-y-2"
      @update="onCarouselItemDragEnd"
    >
      <CarouselItem
        v-for="(item, i) in props.blockChildren"
        :key="
          item.attributes.src
            ? item.attributes.src + i
            : 'no-src-provided-yet-' + i
        "
        :item="item"
        :index="i"
      ></CarouselItem>
    </VueDraggable>

    <TButton
      key="trigger-button"
      data-testid="add-another-item"
      :disabled="canAddMoreImages"
      class="mt-4"
      @click="addItem"
    >
      <template #icon>
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 6.25C9.77614 6.25 10 6.02614 10 5.75V4.25C10 3.97386 9.77614 3.75 9.5 3.75L6.25 3.75V0.5C6.25 0.223858 6.02614 0 5.75 0L4.25 0C3.97386 0 3.75 0.223858 3.75 0.5V3.75H0.5C0.223858 3.75 0 3.97386 0 4.25V5.75C0 6.02614 0.223858 6.25 0.5 6.25L3.75 6.25L3.75 9.5C3.75 9.77614 3.97386 10 4.25 10H5.75C6.02614 10 6.25 9.77614 6.25 9.5V6.25H9.5Z"
            fill="currentColor"
          />
        </svg>
      </template>
      {{ $t("forms.social_add") }}
    </TButton>
  </div>
</template>

<script setup lang="ts">
  import CarouselItem from "./CarouselItem.vue";
  import CarouselItemType from "./CarouselItem";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TButton } from "@topol/twig-ui";
  import { VueDraggable } from "vue-draggable-plus";
  import { computed } from "vue";

  const mjmlStore = useMjmlStore();

  const props = defineProps<{
    blockChildren: CarouselItemType[];
  }>();

  const onCarouselItemDragEnd = (evt: {
    oldIndex: number | undefined;
    newIndex: number | undefined;
  }) => {
    mjmlStore.reorderBlockChildren({
      sectionIndex: mjmlStore.selectedBlock?.sectionIndex,
      columnIndex: mjmlStore.selectedBlock?.columnIndex,
      blockIndex: mjmlStore.selectedBlock?.blockIndex,
      oldIndex: evt.oldIndex,
      newIndex: evt.newIndex,
    });
  };

  const canAddMoreImages = computed(() => {
    return props.blockChildren.length + 1 > 5;
  });

  const addItem = () => {
    if (props.blockChildren.length + 1 < 6) {
      mjmlStore.addBlockChild({
        sectionIndex: mjmlStore.selectedBlock?.sectionIndex,
        columnIndex: mjmlStore.selectedBlock?.columnIndex,
        blockIndex: mjmlStore.selectedBlock?.blockIndex,
        childIndex: props.blockChildren.length,
        value: {
          tagName: "mj-carousel-image",
          attributes: {
            src: "",
          },
        },
      });
    }
  };
</script>
